// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h5 {\n  line-height: 1.6; }\n\n.title {\n  margin-top: 70px; }\n\n.container {\n  box-sizing: border-box; }\n", ""]);
// Exports
module.exports = exports;


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/terms/terms.component.scss
// module id = 1011
// module chunks = 0